import { Grid, Box, Divider } from "@mui/material"
import { StatCard } from "./StatCard"
import { format } from "date-fns"
import DifferenceIcon from '@mui/icons-material/Difference';
import SearchIcon from '@mui/icons-material/Search';
import PublicIcon from '@mui/icons-material/Public';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import WebIcon from '@mui/icons-material/Web';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useDashboardSummaryService } from "../../../../../use-cases/dashboard-summary";
import { useAppSelector } from "../../../../hooks/store-hooks";
import { useEffect } from "react";
import { ConsumoCard } from "./ConsumoCard";
import { ITipoUsuario } from "../../../../../application/models";

export const GeneralStats = () => {
  const {
    clientesAtivos,
    consumoAPITotalHoje,
    consumoIATotalHoje,
    consumoIDTotalHoje,
    consumoTotalHoje,
    consumoTotalMensal,
    consumoGeoTOTALHoje,
    consumoAutoTOTALHoje,
    consumoScrapyTOTALHoje,

    consumoIATotalMensal,
    consumoIDTotalMensal,
    consumoAPITotalMensal,
    consumoGeoTOTALMensal,
    consumoAutoTOTALMensal,
    consumoScrapyTOTALMensal,
    usuariosAtivos
  } = useAppSelector((state) => state.dashboardSummary)
  const { currentUser } = useAppSelector((state) => state.user)

  const isCliente = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE

  const { getDashboardSummaryData } = useDashboardSummaryService()

  useEffect(() => {
    getDashboardSummaryData()
  }, [getDashboardSummaryData])

  return (
    <Grid container spacing={3}>
      {/* Primeira linha com cards principais */}
      {/* Card de Clientes Ativos - Oculto para usuários do tipo CLIENTE */}
      {!isCliente && (
        <Grid item xs={12} md={isCliente ? 6 : 4} lg={isCliente ? 6 : 4}>
          <StatCard
            title={"Clientes Ativos".toUpperCase()}
            value={clientesAtivos.toLocaleString('pt-BR')}
            date={format(new Date(), 'dd/MM/yyyy')}
            link="https://veles.com.br"
            linkText="Ver clientes"
          />
        </Grid>
      )}

      <Grid item xs={12} md={isCliente ? 6 : 4} lg={isCliente ? 6 : 4}>
        <StatCard
          title={"Usuários Ativos".toUpperCase()}
          value={usuariosAtivos.toLocaleString('pt-BR')}
          date={format(new Date(), 'dd/MM/yyyy')}
          link="https://veles.com.br"
          linkText="Ver usuários"
        />
      </Grid>

      {/* Card combinado de consumo */}
      <Grid item xs={12} md={isCliente ? 6 : 4} lg={isCliente ? 6 : 4}>

        <Box
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 220,
            backgroundColor: 'white',
            borderRadius: 1,
            boxShadow: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
            <TrendingUpIcon color="primary" sx={{ mr: 1 }} />
            <Box component="h2" sx={{
              fontSize: '1.25rem',
              fontWeight: 'bold',
              color: 'primary.main',
              m: 0
            }}>
              {"CONSUMO"}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1 }}>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <CalendarMonthIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                <Box component="p" sx={{
                  fontSize: '0.875rem',
                  color: 'text.secondary',
                  m: 0,
                  fontWeight: 'medium'
                }}>
                  MENSAL - {format(new Date(), 'MM/yyyy')}
                </Box>
              </Box>
              <Box component="p" sx={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                m: 0,
                lineHeight: 1.2
              }}>
                {consumoTotalMensal.toLocaleString('pt-BR')}
              </Box>
            </Box>

            <Divider sx={{ my: 0.5 }} />

            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <TodayIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                <Box component="p" sx={{
                  fontSize: '0.875rem',
                  color: 'text.secondary',
                  m: 0,
                  fontWeight: 'medium'
                }}>
                  HOJE
                </Box>
              </Box>
              <Box component="p" sx={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                m: 0,
                lineHeight: 1.2
              }}>
                {consumoTotalHoje.toLocaleString('pt-BR')}
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>

      {/* Segunda linha com 6 cards de consumo específico */}
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <ConsumoCard
              icon={<DifferenceIcon color="primary" />}
              title="IA_VELES"
              valueHoje={consumoIATotalHoje}
              valueMensal={consumoIATotalMensal}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <ConsumoCard
              icon={<SearchIcon color="primary" />}
              title="ID_VELES"
              valueHoje={consumoIDTotalHoje}
              valueMensal={consumoIDTotalMensal}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <ConsumoCard
              icon={<PublicIcon color="primary" />}
              title="API_VELES"
              valueHoje={consumoAPITotalHoje}
              valueMensal={consumoAPITotalMensal}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <ConsumoCard
              icon={<LocationOnIcon color="primary" />}
              title="GEO_VELES"
              valueHoje={consumoGeoTOTALHoje}
              valueMensal={consumoGeoTOTALMensal}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <ConsumoCard
              icon={<AutoModeIcon color="primary" />}
              title="AUTO_VELES"
              valueHoje={consumoAutoTOTALHoje}
              valueMensal={consumoAutoTOTALMensal}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <ConsumoCard
              icon={<WebIcon color="primary" />}
              title="SCRAPY_VELES"
              valueHoje={consumoScrapyTOTALHoje}
              valueMensal={consumoScrapyTOTALMensal}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}